module.exports = __webpack_public_path__ + "img/sport-m-3.656ffe6c.jpg";